import { render, staticRenderFns } from "./PDFViewer.vue?vue&type=template&id=4bfe5de2&"
import script from "./PDFViewer.vue?vue&type=script&lang=js&"
export * from "./PDFViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bfe5de2')) {
      api.createRecord('4bfe5de2', component.options)
    } else {
      api.reload('4bfe5de2', component.options)
    }
    module.hot.accept("./PDFViewer.vue?vue&type=template&id=4bfe5de2&", function () {
      api.rerender('4bfe5de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/PDFViewer.vue"
export default component.exports